import { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { UserProvider } from '@/contexts/UserContext';
import api from '@/lib/api';

export default function ProtectedRoute({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(location.state?.user || null);
  const [checking, setChecking] = useState(!location.state?.user);

  const refreshUser = useCallback(() => {
    return api.get('/auth/me').then(res => { setUser(res.data); return res.data; });
  }, []);

  useEffect(() => {
    if (user) { setChecking(false); return; }
    refreshUser()
      .then(() => setChecking(false))
      .catch(() => { navigate(`/login?next=${encodeURIComponent(location.pathname)}`, { replace: true }); });
  }, [user, navigate, location.pathname, refreshUser]);

  if (checking && !user) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto" />
      </div>
    );
  }
  if (!user) return null;

  const contextValue = { ...user, refreshUser };
  return <UserProvider value={contextValue}>{children}</UserProvider>;
}
